<script>
import isObject from 'lodash/isObject';
import Tooltip from 'tooltip.js';

export default {
  props: {
    processing: Boolean,
    heading: [Object, String],
    sortColumn: String,
    sortDirection: Number,
  },
  computed: {
    isSort() {
      return isObject(this.heading) && this.heading.name && this.heading.prop;
    },
    isAction() {
      return isObject(this.heading) && this.heading.icon && this.heading.action;
    },
    isHelp() {
      return isObject(this.heading) && this.heading.name && this.heading.help;
    },
    isTooltip() {
      return isObject(this.heading) && this.heading.name && this.heading.tooltip;
    },
  },
  async mounted() {
    if (this.$refs.tooltip) {
      await this.$nextTick();

      this.helpTooltip = new Tooltip(this.$refs.tooltip, {
        trigger: 'hover',
        placement: 'left',
        title: this.heading.tooltip,
        html: false,
        container: '#content',
      });
    }
  },
  beforeDestroy() {
    if (this.helpTooltip) {
      this.helpTooltip.dispose();
    }
  },
  methods: {
    handleClickHeaderAction() {
      if (!this.processing) {
        this.$emit('header-action', this.heading.action);
      }
    },
    handleSortClick() {
      if (this.isSort) {
        this.$emit('sort', this.heading.prop);
      }
    },
  },
};
</script>

<template lang='pug'>
.vs-table__heading(
  :class='{ \
    "vs-table__heading--sort": isSort, \
    "vs-table__heading--action": isAction, \
  }',
  @click='handleSortClick',
)
  template(v-if='isSort')
    h6
      strong {{heading.name}}&nbsp;
      span.mdi.mdi-help-circle(
        v-if='heading.tooltip',
        ref='tooltip',
      )
      .vs-table__sort
        .mdi.mdi-chevron-up.vs-table__icon(
          :class='{ "vs-table__icon--active": sortColumn === heading.prop && sortDirection === 0 }',
        )
        .mdi.mdi-chevron-down.vs-table__icon(
          :class='{ "vs-table__icon--active": sortColumn === heading.prop && sortDirection === 1 }',
        )

  template(v-else-if='isAction')
    i(:class='heading.icon', @click='handleClickHeaderAction')

  template(v-else-if='isHelp')
    h6
      strong {{heading.name}}&nbsp;
      span.mdi.mdi-help-circle(@click='$emit("help")')

  template(v-else-if='isTooltip')
    h6
      strong {{heading.name}}
      span.mdi.mdi-help-circle(
        v-if='heading.tooltip',
        ref='tooltip',
      )

  template(v-else)
    h6
      strong {{heading}}
</template>

<style>
@import '~import/index';
</style>